<template>
  <div class="recruitalents_box">
    <div class="banner">
      <div class="top">
        <div class="title">加入我们</div>
        <div class="titleSc">Join us</div>
      </div>
      <img class="bannerimg" :src="$baseUrl + img_src.banner" alt="banner" />
    </div>
    <typebutton :current_type="current_type" :typeList="typeList" @checkType="checkType($event)"></typebutton>
    <!-- 内容 -->
    <div class="Recruitalents_content">
      <!-- 招聘列表 -->
      <div v-if="showlist">
        <div v-if="datalist[current_type].length > 0">
          <el-row class="elrow">
            <el-col class="elcol" :span="12" v-for="(item, index) in datalist[current_type]" :key="'datalitst' + index">
              <div class="datalitst" @click="detail(item, index)">
                <div class="list_title">
                  <div class="list_info">
                    <div class="title">{{ item.title }}</div>
                    <div class="type">
                      <span>学历：{{ item.educational }}</span>
                      <span style="margin: 0 37px">经验：{{ item.experience }}</span>
                      <span>人数：{{ item.num }}</span>
                    </div>
                  </div>
                  <img :src="item.head" width="52px" height="57px" alt />
                </div>
                <div class="list_detail">
                  <div class="detail">职位详情</div>
                  <span style="color: #777777">时间：{{ item.date }}</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div style="height: 500px; display: flex; justify-content: center" v-else>
          <el-empty description="暂无招聘信息哦"></el-empty>
        </div>
      </div>
      <!-- 详情 -->
      <div v-if="showdetail">
        <div class="div_detail">
          <div class="detail_title">
            <div class="detail_info">
              <div class="title">{{ detailtitle }}</div>
              <div class="type">
                <span>学历：{{ detaileducational }}</span>
                <span style="margin: 0 79px">经验：{{ detailexperience }}</span>
                <span>人数：{{ detailnum }}</span>
              </div>
            </div>
            <div style="color: #777777">时间：{{ detaildate }}</div>
          </div>
          <div class="detail_content">
            <div class="title">岗位职责：</div>
            <p style="margin-top: 20px; white-space: pre-wrap" v-html="detailzhize"></p>
            <div class="title">任职要求：</div>
            <p style="margin-top: 10px; white-space: pre-wrap" v-html="detailyaoqiu"></p>
            <div class="contact">
              如有意向，简历请投递至1151190745@qq.com
            </div>
          </div>
        </div>
        <div class="back" @click="detail(1, -1)">返回职位列表</div>
      </div>
    </div>
  </div>
</template>
<script>
import typebutton from "../components/typebutton.vue";
export default {
  components: {
    typebutton,
  },
  data() {
    return {
      img_src: {
        banner: "/upload-router-api/personPhoto/2024/11/13/1731484007517162202.png",
      },
      typeList: [
        { title: "技术研发类" },
        { title: "市场销售类" },
        { title: "职能类及其他" },
      ],
      datalist: [
        //技术研发
        [
          {
            title: "JAVA开发",
            head: "/static/images/RecruitTalents/jobhead.png",
            num: 1,
            educational: "大专及以上学历",
            experience: "1年以上",
            date: "2022-10-18",
            zhize:
              "" +
              "1、主要负责后端接口开发、功能模块设计、代码实现\n" +
              "2、维护及优化公司项目系统，对需求进行分析评审，提出合理化建议\n" +
              "3、配合联调测试、接口对接",
            yaoqiu:
              "1、计算机相关专业，有项目经验，代码质量高，安全意识强\n" +
              "2、 扎实的计算机基础，熟悉常用的数据结构、算法、设计模式，对面向对象编程理解深刻\n" +
              "3、Java基础扎实，理解io，多线程，集合等基础框架，对jvm原理有一定的了解\n" +
              "4、 掌握springboot、mybatis等流行开发框架\n" +
              "5、 熟悉git工具、linux常用命令\n" +
              "6、 熟悉mysql或oracle、能熟练编写sql及sql优化，了解redis、mongodb\n" +
              "7、 有大型分布式、高并发、高负载、高可用性系统的设计开发经验者优先，兼具前端知识者优先\n" +
              "8、具有较强的学习能力，工作认真负责，有良好的沟通协调能力与团队合作精神\n" +
              "9、 能独立解决问题，有较强的执行力\n",
          },
        ],
        //销售
        [
          {
            title: "销售代表",
            head: "/static/images/RecruitTalents/jobhead.png",
            num: 1,
            educational: "大专及以上学历",
            experience: "1年以上",
            date: "2022-10-18",
            zhize:
              "1、建立负责区域的医院档案，定期进行跟踪拜访；\n" +
              "2、建立负责区域的经销商档案，定期电话、上门拜访，建立关系，做好公司桥梁工作，保证公司产品的正常销售；\n" +
              "3、对所辖区域内销售额负责，达到上级交给的销售指标任务；\n" +
              "4、主动了解竞争产品，收集并记录竞争对手信息，努力做好知己知彼；\n" +
              "5、完成领导交代其他事项\n" +
              "工作内容；\n" +
              "1、按照公司的要求完成工作日报，月报，季度报，并不断补充销售机会及竞争对手信息；\n" +
              "2、定期拜访区域内的医院、经销商目标客户表，了解他们的需求并提供合理的解决方案；\n" +
              "3、努力提高自身的专业知识，通过个人专业销售推广，树立良好的公司和产品形象；\n" +
              "4、配合公司做好学术会议的推广，向医院相关人员传递产品知识和信息，以提高产品的市场占有份额；\n" +
              "5、完成省区销售经理下达的销售任务，影响并说服负责区域内医院的经销商推荐购买公司产品；\n",
            yaoqiu:
              "1、大专及以上学历，市场营销、生物工程，制药工程，机械自动化等理工科相关专业；\n" +
              "2、有1年以上医疗器械销售工作经验优先，业绩突出者优先；\n" +
              "3、具备一定的市场分析及判断能力，良好的客户服务意识；\n" +
              "4、性格外向、反应敏捷、表达能力强，具有较强的沟通能力及交际技巧，有亲和力；\n",
          },
        ],
        //职能类
        [
          {
            title: "文案策划",
            head: "/static/images/RecruitTalents/jobhead.png",
            num: 1,
            educational: "大专及以上学历",
            experience: "1年以上",
            date: "2022-10-18",
            zhize:
              "1、负责撰写产品上市、品牌推广等宣传方案，并落实跟进执行；\n" +
              "2、负责公众号的运营维护，扩大公司品牌形象宣传力度；\n" +
              "3、根据公司品牌和产品推广的需要，撰写有吸引力的媒体软文\n" +
              "4、负责跟进和落实设计方案的实施及细节的把握；\n" +
              "5、负责文字构思和设计编排。\n",
            yaoqiu:
              "1、熟练word、excel、PPT、PS、CAD等其他办公软件及图片处理软件； \n" +
              "2、熟悉专业创意方法，思维敏捷，洞察力强\n" +
              "3、对文案策划有兴趣，能撰写各类活动的企划文案；\n" +
              "4、优秀深厚的文字功底，有较强的文字表现力和策划能力；\n" +
              "5、较强的创造性思维，良好的沟通表达能力；\n" +
              "6、有良好的敬业精神、创新意识工作主动，有责任感及团队合作意识。\n",
          },
        ],
      ],
      current_type: 0,
      showlist: true,
      showdetail: false,
      detailtitle: "",
      detaileducational: "",
      detailexperience: "",
      detailnum: "",
      detaildate: "",
      detailzhize: "",
      detailyaoqiu: "",
    };
  },

  watch: {
    showlist: {
      handler(newName, oldName) {
        if (window.history && window.history.pushState) {
          history.pushState(null, null, document.URL);
          window.addEventListener("popstate", this.goBack, false);
        }
      },
    },
  },
  mounted() {
    console.log("mounted");
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.goBack, false);
    }
  },
  destroyed() {
    console.log("destroyed");
    window.removeEventListener("popstate", this.goBack, false);
  },
  methods: {
    goBack() {
      if (this.showlist) {
        this.$router.go(-1); //返回上一层
      } else {
        this.showdetail = !this.showdetail;
        this.showlist = !this.showlist;
      }
    },
    checkType(index) {
      this.showdetail = false;
      this.showlist = true;
      console.log("22222");
      this.current_type = index;
      console.log(index);
    },
    //职位详情/返回列表
    detail(item, index) {
      if (index >= 0) {
        (this.detailtitle = item.title),
          (this.detaileducational = item.educational),
          (this.detailexperience = item.experience),
          (this.detailnum = item.num),
          (this.detaildate = item.date);
        this.detailzhize = item.zhize;
        this.detailyaoqiu = item.yaoqiu;
      }
      this.showdetail = !this.showdetail;
      this.showlist = !this.showlist;
    },
  },
};
</script>
<style scoped lang="less">
.recruitalents_box {
  .banner {
    min-width: 1200px;
    margin-bottom: 30px;
    position: relative;

    .bannerimg {
      width: 100%;
      height: 500px;
    }

    .top {
      position: absolute;
      top: 262px;
      left: 423px;
      color: #fff;

      .title {
        font-size: 48px;
        line-height: 12px;
        color: #ffffff;
      }

      .titleSc {
        font-size: 28px;
        line-height: 12px;
        color: #ffffff;
        margin-top: 60px;
      }
    }
  }

  //=====内容====
  .Recruitalents_content {
    cursor: pointer;
    margin: 0 auto;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .elrow {
      margin-top: 60px;
      margin-bottom: 40px;
      width: 1130px;
    }

    .elcol {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .datalitst:hover {
      border: 3px solid #2525cc;

      .list_detail .detail {
        background: #2525cc;
        color: white;
      }
    }

    .datalitst {
      border: 3px solid white;
      box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.12);
      width: 524px;
      height: 190px;
      padding: 30px;
      margin-bottom: 40px;

      .list_title {
        display: flex;
        justify-content: center;
        align-items: center;

        .list_info {
          display: flex;
          flex-direction: column;
          flex: 1;

          .title {
            color: #333333;
            font-size: 24px;
            font-weight: bold;
          }

          .type {
            color: #a2a2a2;
            font-size: 14px;
            margin-top: 20px;
            gap: 160px;
          }
        }

        .download {
          cursor: pointer;
          color: #fff;
          width: 120px;
          text-align: center;
          line-height: 44px;
          height: 44px;
          background-color: #2525cc;
        }
      }

      .list_detail {
        line-height: 30px;
        margin-top: 26px;
        display: flex;
        justify-content: space-between;
        color: #212121;
        margin-bottom: 340px;

        .detail {
          width: 121px;
          line-height: 40px;
          color: #2525cc;
          height: 40px;
          font-size: 14px;
          text-align: center;
          border: 1px solid #2525cc;
        }
      }
    }

    //=====服务详情====
    .div_detail {
      padding: 40px;
      width: 1200px;
      margin-top: 60px;
      margin-bottom: 30px;
      box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.12);

      .detail_title {
        display: flex;
        align-items: flex-end;

        .detail_info {
          display: flex;
          flex-direction: column;
          flex: 1;

          .title {
            color: #333333;
            font-size: 24px;
            font-weight: bold;
          }

          .type {
            color: #a2a2a2;
            font-size: 14px;
            margin-top: 20px;
          }
        }

        .download {
          cursor: pointer;
          color: #fff;
          width: 120px;
          text-align: center;
          line-height: 44px;
          height: 44px;
          background-color: #2525cc;
        }
      }

      .detail_content {
        line-height: 30px;
        color: #212121;

        .title {
          margin-top: 20px;
          color: #333333;
          font-size: 18px;
          font-weight: bold;
        }

        .contact {
          margin-top: 70px;
          margin-bottom: 20px;
          text-align: center;
        }
      }
    }

    .back {
      color: #333333;
      width: 147px;
      height: 47px;
      text-align: center;
      margin-bottom: 140px;
      line-height: 47px;
      font-size: 14px;
      border: 1px solid #c9c9c9;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/RecruitTalents.vue